import { render, staticRenderFns } from "./ResultGood.vue?vue&type=template&id=6c5cdd6c&scoped=true&"
import script from "./ResultGood.vue?vue&type=script&lang=js&"
export * from "./ResultGood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5cdd6c",
  null
  
)

export default component.exports